import React from "react";
import GameMarkets from "../gameMarkets";
import AnimationWrapper from "../animationWrapper";
import { browserHistory } from "react-router";
import Loader from "../../components/loader";
import Config from '../../../config/main';
import { toggleGameEventsInList, moveGameEvevntsInList } from '../../../actions/ui';
import {t} from "../../../helpers/translator";
import BetBuilderIcon from "../betBuilderWrapper/components/betBuilderIcon";
const typeToString = {
    1: 'live',
    0: 'prematch',
    2: 'prematch'
};

export default function GameWrapperTemplate () {
    let { routeParams, params, data, selectorKey, virtualGameId, providerId, loading, cursor, gameArray } = this.props,
        gameId,
        sportAlias;
    if (!virtualGameId && routeParams && params) {
        gameId = routeParams.gameId;
        sportAlias = params.sportAlias;
    }

    const urlDestruct = location.pathname.split("/"); // Chhayhohel ... bayc esli shto Armanna grel

    if (data || this.state.someLoading) {
        if (!data && this.state.someLoading) {
            return <div className="gameIsNotAvailable">{t("Game is not available")}</div>;
        }
        return (<div className="single-game-view-w" ref={(el) => this.scrollMarkets = el} onClick={this.props.uiClose("openRegion")}>
            {
                Config.main.enableAppearGame ? (
                    !virtualGameId && <div className="b-c-wrapper">
                        <div className="bread-crumbs-view-m">
                            <span className='span-wrapp'>
                                <span onClick={() => {
                                    this.props.dispatch(toggleGameEventsInList(false, 0));
                                }} className="close-arrow-crumbs" />
                            </span>
                            <span className='span-wrapp'>
                                <span
                                    onClick={() => { this.props.dispatch(moveGameEvevntsInList(-1)); }}
                                    className={`back-arrow-crumbs ${(cursor - 1) < 0 ? 'disabled' : ''}`}
                                />
                            </span>
                            <span className='span-wrapp right-arr'>
                                <span
                                    onClick={() => { this.props.dispatch(moveGameEvevntsInList(1)); }}
                                    className={`forward-arrow-crumbs ${(cursor + 1) >= gameArray.length ? 'disabled' : ''}`}
                                />
                            </span>
                            {
                                data && (
                                    <p>
                                        <span>{data.sportName}</span>
                                        <span>/ {data.regionName}</span>
                                        <span>/ {data.competitionName}</span>
                                    </p>
                                )
                            }
                        </div>
                    </div>
                ) : (
                    !virtualGameId && <div className="b-c-wrapper">
                        <div className="bread-crumbs-view-m">
                            <span className='span-wrapp'>
                                <span onClick={() => browserHistory.push(urlDestruct.slice(0, urlDestruct.length - 1).join('/'))} className="back-arrow-crumbs" />
                            </span>
                            {data && (
                                    <p>
                                        <span>{data.sportName}</span>
                                        <span>/ {data.regionName}</span>
                                        <span>/ {data.competitionName}</span>
                                    </p>
                                )}
                        </div>
                    </div>
                )
            }
            {data && !virtualGameId && typeToString[data.gameType] !== "live" ? <div className="league-name-view-m">
                <h3>{data.team1_name} {data.team2_name ? " - " + data.team2_name : ""}</h3>
            </div> : null}
            {
                data && <>
                    <AnimationWrapper gameId={virtualGameId || gameId}
                        isVirtualGame={!!virtualGameId}
                        selectorKey={selectorKey}
                        gameType={typeToString[data.gameType]}
                        sportAlias={data.sportAlias}
                        providerId={providerId}
                        showType = {data.showType}
                    />
                    <GameMarkets game={data} selectorKey={selectorKey} key={virtualGameId || gameId} />
                </>
            }
            {
                data && !virtualGameId && <div className="scroll-b-view-w">
                    <div className="single-s-b top-v" onClick={this.scroll(-200)} />
                    <div className="single-s-b bot-v" onClick={this.scroll(200)} />
                </div>
            }
        </div>);
    } else {
        return <Loader />;
    }
}